import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import injectSheet from "react-jss";

const Heading = ({ classes, level = 2, text, nowrap }) => {
  const H = level > 6 ? "h6" : `h${level}`;
  return (
    <H
      className={classNames({
        [classes.root]: true,
        [classes.level1]: level === 1,
        [classes.level2]: level === 2,
        [classes.level3]: level === 3,
        [classes.level4]: level === 4,
        [classes.level5]: level === 5,
        [classes.level6]: level === 6,
        [classes.nowrap]: nowrap
      })}
    >
      {text}
    </H>
  );
};

Heading.propTypes = {
  classes: PropTypes.object.isRequired,
  level: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  text: PropTypes.string.isRequired,
  nowrap: PropTypes.bool
};

const styles = theme => ({
  root: {
    color: theme.colors.headings,
    margin: 0
  },
  level1: {
    fontSize: "2.5rem",
    fontWeight: 400
  },
  level2: {
    fontSize: "2.1rem",
    fontWeight: 400
  },
  level3: {
    fontSize: "1.8rem",
    fontWeight: 400
  },
  level4: {
    fontSize: "1.5rem",
    fontWeight: 600,
    textTransform: "uppercase",
    color: theme.colors.gray[3],
    marginBottom: 15
  },
  nowrap: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap"
  }
});

export default injectSheet(styles)(Heading);



// WEBPACK FOOTER //
// ./src/components/shared/Heading.js